import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ItemTitle, ItemContent } from '../DarkWebStyles';
import Modal from '../../../../../CommonComponents/Modal';
import AddressForm from './AddressForm';
import { Alert } from '../../../../../CommonComponents/Alert/Alert';
import { setDarkWebModalErrors } from '../../../../ExperianActions';
import { darkWebModalErrorsSelector } from '../../../../ExperianSelector';
import { DataItem, DataItemText, EditIcon, ModalContent } from '../DarkWebModal/DarkWebModalStyles';

const Address = ({ title, data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    Address1: address1,
    Address2: address2,
    City: city,
    CountryCode: countryCode,
    State: state,
    ZipCode: zip,
  } = data;

  const darkWebModalErrors = useSelector(darkWebModalErrorsSelector);

  const dispatch = useDispatch();
  const onCancelCallback = useCallback(() => {
    setIsModalOpen(false);
    dispatch(setDarkWebModalErrors([]));
  }, [dispatch]);

  return (
    data &&
    Object.keys(data).length > 0 && (
      <>
        <div>
          <ItemTitle>{title}</ItemTitle>
          <DataItem>
            <EditIcon onClick={() => setIsModalOpen(true)} />
            <DataItemText>
              <ItemContent>
                {!!address1 && <div>{address1}</div>}
                {!!address2 && <div>{address2}</div>}
                <div style={{ display: 'flex' }}>
                  {!!city && <div>{`${city},`}&nbsp;</div>}
                  {!!state && (
                    <div>
                      {state} {zip}
                    </div>
                  )}
                </div>
                {!!countryCode && <div>{countryCode}</div>}
              </ItemContent>
            </DataItemText>
          </DataItem>
        </div>
        <Modal isOpen={isModalOpen}>
          <ModalContent>
            {darkWebModalErrors.length > 0 && <Alert message={darkWebModalErrors} />}
            <AddressForm data={data} onCancel={onCancelCallback} />
          </ModalContent>
        </Modal>
      </>
    )
  );
};

export default Address;
